"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var is_hotkey_1 = __importDefault(require("is-hotkey"));

var Type_1 = require("./Type");

var plugin_factory_1 = require("./plugin-factory");

var useKeyBoardShortcut = function useKeyBoardShortcut(Component) {
  var _a;

  var type = Component.type,
      id = Component.id,
      keyboardKey = Component.keyboardKey;

  if (!keyboardKey) {
    throw Error('keyboardKey need to get ShortcutPlugin');
  }

  var toggle = (_a = {}, _a[Type_1.RichTextItemType.block] = plugin_factory_1.createToggleBlock(id), _a[Type_1.RichTextItemType.mark] = plugin_factory_1.createToggleMark(id), _a[Type_1.RichTextItemType.inline] = plugin_factory_1.createToggleInline(id), _a)[type];
  return {
    toggle: toggle,
    key: keyboardKey
  };
};

var useKeyBoardShortcuts = function useKeyBoardShortcuts(props) {
  var editor = props.editor,
      components = props.components;
  var hotKeys = Object.values(components) // eslint-disable-next-line no-prototype-builtins
  .filter(function (Component) {
    return Component.hasOwnProperty('keyboardKey');
  }).map(function (Component) {
    return useKeyBoardShortcut(Component);
  });
  return {
    onKeyDown: function onKeyDown(event) {
      hotKeys.forEach(function (hotkey) {
        if (is_hotkey_1.default(hotkey.key, event)) {
          event.preventDefault();
          hotkey.toggle({
            editor: editor
          });
        }
      });
    }
  };
};

exports.default = useKeyBoardShortcuts;